import React from 'react'
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import Tooltip from 'react-bootstrap/Tooltip';
import NewEditDoor from './NewEditDoor.js'
import { Link } from 'react-router-dom';
import {Row, Button } from 'react-bootstrap';
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";

const TableHeader = () => {
  return (

    <thead>
      <tr>
        <th style={{width:'2%'}}>Qty</th>
        <th style={{width:'10%'}}>Width(in) x Height(in)</th>
        <th className='d-none d-sm-table-cell' style={{width:'5%'}}>Product Type</th>
        <th style={{width:'10%'}}>Brand</th>
        <th style={{width:'25%'}}>Color</th>
        <th style={{width:'5%'}}>Door Style</th>
        <th style={{width:'5%'}}>Hinge Borring</th>
        <th style={{width:'2%'}}>Edit</th>
        <th style={{width:'2%'}}>Delete</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {
  if (props.doorsObj) {
    const rows = props.doorsObj.map((row, index) => { 
      var producttype;
      var doorstyle;
      if (row.producttype.producttype) {
        producttype = row.producttype.producttype;
      }
      else {
        producttype = props.producttypes.filter(prod => {
          return prod.id == row.producttype;
        })
        producttype = producttype[0]["producttype"];        
      }

      if (row.doorstyle.doorstyle) {
        doorstyle = row.doorstyle.doorstyle;
      }
      else {
        doorstyle = props.doorstyles.filter(style => {
          return style.id == row.doorstyle;
        })
        doorstyle = doorstyle[0]["doorstyle"];
      } 

      return (      
        <tr key={index}>        
          <td>
            {row.doorqty}
          </td>
          <td>  
            {row.doorwidth + "\" x " + row.doorheight + "\""}
          </td>
          <td className='d-none d-sm-table-cell'>  
            {producttype}
          </td>        
          <td className='d-none d-sm-table-cell'>  
            {row.brand.materialbrandname}
          </td>   
          <td className='d-none d-sm-table-cell'>  
            {row.color.materialcolorname}
          </td>   
          <td className='d-none d-sm-table-cell'>  
            {doorstyle}
          </td>                     
          <td className='d-none d-sm-table-cell'>  
            {parseInt(row.hingeborring)===0?"No":"Yes"}
          </td>                                                
          <td>  
            {/**
            <Button
              disabled={props.mode===2}
              onClick={() => {
                props.editItem(index);
              }}>
              <FaEdit color='white'/>
            </Button>      
            */}
            
            <NewEditDoor 
              mode={props.mode} 
              doorsmode={1}
              addeditems={props.doorsObj} 
              editItem={props.editItem}
              door={row}
              producttypes={props.producttypes}
              doorstyles={props.doorstyles}
              setShowerror={props.setShowerror}
              setErrmessage={props.setErrmessage}
              index={index}
            />
          </td> 
          <td>  
            <Button 
              disabled={props.mode===2}
              onClick={() => {
                props.removeItem(index);
              }}             
              style={{backgroundColor:"#FFC7CE",borderStyle:"none"}} >
              <MdDelete  color="#9C0006" size={25}/>
            </Button>      
          </td>                        
        </tr>
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const renderEditTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Click to edit the door.
  </Tooltip>
);



const DoorsList = (props) => {        
  
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline"}} striped bordered hover size="sm">
            <TableHeader />
            <TableBody 
              doorstyles={props.doorstyles}
              producttypes={props.producttypes}
              doorsObj={props.listOfDoors} 
              removeItem={props.removeItem} 
              editItem={props.editItem} 
              mode={props.mode}
              doorsArrayFunction={props.doorsArrayFunction}
              setShowerror={props.setShowerror}
              setErrmessage={props.setErrmessage}              
            />
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
}

export default DoorsList;